import PageLoading from '@/components/page-loading';
import loadable from '@loadable/component';

export default [
    {
        path: '/openapi/oauth/authorize',
        component: loadable(() => import(/* webpackChunkName: "openapi-oauth" */ `@/views/openapi/OAuthAuthorize`), { fallback: <PageLoading /> }),
    },
] as ReactRoute[];
